module.exports = __webpack_public_path__ + "img/clipboard.03828d5a.svg";